import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GuidedCreation } from 'src/app/beans/guided-creation/guided.creation.bean';
import { OrganizationData  } from 'src/app/beans/organization/organization.data.bean';
import { Place } from 'src/app/beans/place/place.bean';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { Notifier } from 'src/app/enums/notifier/notifier.enum';
import { isSessionCode } from 'src/app/enums/session/session-code.enum';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';

@Component
({
  selector: 'stepper-module-1',
  templateUrl: './module.1.html',
  styleUrls: ['./module.1.scss']
})

export class StepperModule1 implements OnInit 
{
  _organization   : OrganizationData
  _guided_creation: GuidedCreation

  @Output() change: EventEmitter<number> = new EventEmitter<number>()

  constructor
  (
    private _util    : UtilsManager   ,
    private _notifier: NotifierManager,
    private _session : SessionManager ,
  ) {}

  ngOnInit(): void
  {
    this.initObjects()
  }

  checkInput()
  {
    this.initObjects()

    if(!this._util.checker().isValidText(this._organization.name))
    {
      this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_ORG_NAME)
      this.change.emit(0)
      return
    }

    // if(!this._util.checker().isValidText(this._organization.municipality))
    // {
    //   this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_ORG_MUNICIPALITY)
    //   this.change.emit(0)
    //   return
    // }

    if(!this._util.checker().isValidText(this._organization.zipCode))
    {
      this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_ORG_ZIPCODE)
      this.change.emit(0)
      return
    }

    if(!this._util.checker().isValidText(this._organization.address))
    {
      this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_ORG_ADDRESS)
      this.change.emit(0)
      return
    }

    if(!this._util.checker().isValidId(this._organization.placeId))
    {
      this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_ORG_PLACE_ID)
      this.change.emit(0)
      return
    }

    // if(!this._util.checker().isValidText(this._organization.addressNumber))
    // {
    //   this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_ORG_ADDRESS_NUMBER)
    //   return
    // }

    if(!this._util.checker().isValidLatitude(this._organization.latitude))
    {
      this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_ORG_LATITUDE)
      this.change.emit(0)
      return
    }

    if(!this._util.checker().isValidLongitude(this._organization.longitude))
    {
      this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_ORG_LONGITUDE)
      this.change.emit(0)
      return
    }

    if(!this._util.checker().isValidEmail(this._organization.email))
    {
      this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_ORG_EMAIL)
      this.change.emit(0)
      return
    }

    if(!this._util.checker().isValidPhoneNumber(this._organization.phone))
    {
      this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_ORG_PHONE)
      this.change.emit(0)
      return
    }

    //If all data was checked then
    this._guided_creation.organization = this._organization

    this._session.guidedCreation().set(this._guided_creation)

    this.change.emit(1)
  }

  initObjects()
  {
    if(!this._guided_creation)
    {
      let object = this._session.guidedCreation().get() as GuidedCreation

      console.log(object);

      if(!isSessionCode(object))
      {
        this._guided_creation = object

        if(this._guided_creation.organization) this._organization = this._guided_creation.organization
        else                                   this._organization = new OrganizationData()
      }
      else
      {
        this._guided_creation = new GuidedCreation()
        this._organization = new OrganizationData()
      }
    }
  }

  placeChanged(el: Place)
  {
    this._organization.placeId = el.id
  }
}
